import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import React from "react";
import api from "../api";
import {FieldControl, FieldGroup} from "react-reactive-form";
import { toast } from 'react-toastify';
import DeleteIcon from '@material-ui/icons/Delete';

export function renderControlButton(control, index) {
    return (
        <div style={{marginLeft:'45px',top: '-10px;'}}>
            {index !== 0 && <Grid item xs={5}>
                <Tooltip title="Supprimer ce fichier">
                    <IconButton style={{color:'#b92d28',top: '-10px;'}} aria-label="remove" onClick={() => removeItemTypeOfProof(control, index)}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Grid>}
        </div>
    )
}


function removeItemTypeOfProof(control, index) {
    if (control.controls && control.controls.length > 1) {
        control.removeAt(index);
    }
}

export function renderFile(formControl) {
    let errorMessage = null;
    let errorHas = null;
    if ((formControl.touched || formControl.submitted) && !!formControl.errors) {
        errorHas = Object.keys(formControl.errors);
    }
    return (
        <div style={{marginBottom:'10px', position: 'relative', top: '13px'}}>
            <input type="file" id="file" name="file" onChange={handleFile(formControl)}/>
            {(formControl.touched || formControl.submitted) && !!formControl.errors && <p className="errorMessage typoRegular">{errorMessage}</p>}
        </div>
    )
}

function handleFile(formControl){

    return (e) => {


        let file = e.target.files[0];
        let data = new FormData();
        data.append('file', file);
        api.media_object.uploadFile(data)
            .then((data) => {
                return getDataUpload(data, formControl);

            })
            .catch((error) => {
            });
    }
}

async function getDataUpload(data, formControl){
    formControl.patchValue(data.data);
    toast.success('Fichier '+data.data.originalName+' téléchargé')

}

export function renderCommentFormGroup(control,title) {

    return control.controls.map((questionControl, index) => {
        return (
            <Grid container key={`${questionControl.meta.key}-${String(index)}`} style={{marginTop: '15px'}}
                  data-cy={'question' + index}>

                <FieldGroup
                    control={questionControl}
                    render={({}) => (
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={11}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <FieldControl
                                            name={title}
                                            render={renderFile.bind(this)}
                                        />
                                    </Grid>
                                    <Grid item xs={1} lg={1}>
                                        {renderControlButton(control, index)}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                />
            </Grid>
        )
    })
}


// WEBPACK FOOTER //
// ./src/services/utils-upload-generic.js